import { Component } from '@angular/core';

import { ListEventService } from './list-event.service';

@Component({
  selector: 'ui-list-item',
  templateUrl: './list-item.component.html',
  providers: [
    // æä¾ä¸ä¸ªæå¡ï¼ä¾ list-sliding ç»ä»¶åèµ·éä¿¡
    ListEventService
  ]
})
export class ListItemComponent {
}